export const environment = {
    production: false,
    apiUrl: 'https://momentumpartnerhubservice.rrzdev.co.za/',
    keycloak:{
        url: 'https://keycloak.rrzdev.co.za/',
        realm:'rrzbase',
        clientId:'rrzbase-public-client'
    }
};